import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentationPage from './DocumentationPage';
import DocumentationPageEs from './DocumentationPage_es';

const DocumentationPageWrapper: React.FC = () => {
    const { i18n } = useTranslation();

    // Renderiza a versão em espanhol se o idioma for espanhol
    if (i18n.language === 'es') {
        return <DocumentationPageEs />;
    }

    // Renderiza a versão em português (padrão)
    return <DocumentationPage />;
};

export default DocumentationPageWrapper;
